import React from 'react';
import { Bounce, Fade, Slide } from 'react-awesome-reveal';
import { Breakpoint } from 'react-socks';

import { Box, Typography } from '@mui/material';
import cx from 'classnames';

import './AlongsideSection.scss';

const AlongsideSection = ({
    title = '',
    desc = '',
    image = '',
    sectionList = [],
    imageFirst = false,
    backgroundColor = '#ffffff',
    sectionClassName = '',
    children
}) => {
    const RenderImage = ({ position }) => (
        <Box className={cx(['sectionImg', position])}>
            <Slide direction={position}>
                <img src={image} alt={title} />
            </Slide>
        </Box>
    );

    return (
        <Box
            className={cx(['alongsideSection', sectionClassName])}
            style={{ backgroundColor }}>
            <Box className="alongsideSectionContent">
                <Breakpoint tablet down>
                    <Fade>
                        <Typography component="h2" className="sectionTitle">
                            {title}
                        </Typography>
                    </Fade>
                </Breakpoint>
                {imageFirst && <RenderImage position="left" />}
                <Box className="sectionContent">
                    <Breakpoint laptop up>
                        <Fade>
                            <Typography component="h2" className="sectionTitle">
                                {title}
                            </Typography>
                        </Fade>
                    </Breakpoint>
                    <Fade>
                        <Typography className="sectionDesc">{desc}</Typography>
                    </Fade>
                    {sectionList.length > 0 && (
                        <Box className="sectionList">
                            {sectionList.map((item, index) => (
                                <Box key={index} className="sectionItem">
                                    <Box className="listIco">
                                        <Bounce>
                                            <img
                                                src={item.icon}
                                                alt={item.title}
                                            />
                                        </Bounce>
                                    </Box>
                                    <Typography>{item.title}</Typography>
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
                {!imageFirst && <RenderImage position="right" />}
                {children}
            </Box>
        </Box>
    );
};

export default AlongsideSection;
